// import React from 'react'
import { motion } from "framer-motion";
import { profile, webHand, resume } from "../../assets";
import { Button } from "@material-tailwind/react";
import { FaUserTie } from "react-icons/fa";
import { MdOutlineDocumentScanner } from "react-icons/md";
import { SiJavascript, SiReact, SiTailwindcss, SiHtml5 } from "react-icons/si";

const hero = () => {
  return (
    <section
      id="home"
      className="py-14 md:min-h-[85vh] flex items-center flex-col-reverse lg:flex-row gap-10 justify-center"
    >
      <motion.div
        initial={{ opacity: 0, y: -100 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7 }}
        className="flex flex-col gap-4 md:gap-6 text-left lg:w-1/2 2xl:w-1/3 mx-6 xl:mx-0 "
      >
        <div className="flex items-center">
          <img
            src={webHand}
            alt="Waving Hand"
            className="w-10 h-10 mr-2 animate-bounce"
          />

          <p className="text-xl font-serif text-gray-800 font-semibold italic">
            廾𝕖ļļₒ
          </p>
        </div>
        <p className="text-2xl md:text-3xl text-gray-900 font-bold relative">
          I&apos;m
          <span className="text-3xl text-light-blue-700 ml-1 uppercase font-serif">
            Sastik Kumar Das
          </span>
        </p>
        <p className=" font-[600] text-xl md:font-semibold relative ">
          System Engineer at TCS | Ex- Developer @TargetGrid | Social Worker @CITADEL
        </p>
        <p className="text-base md:text-xl md:font-medium relative">
        Enthusiastic and curious to DevOps Engineer, with hands-on experience in full-stack web development, specializing in the MERN stack. Proficient in various software management tools such as Git, GitLab, GitHub, Postman, and Jira.
        </p>

        <div className="pt-8 flex flex-row justify-center md:justify-normal gap-4 md:gap-6">
          <a href="#about">
            <Button
              variant="gradient"
              color="light-blue"
              className="flex gap-2 items-center"
            >
              <FaUserTie className="text-lg animate-bounce" />
              About Me
            </Button>
          </a>
          <a href={resume}>
            <Button
              variant="gradient"
              color="light-blue"
              className="flex gap-2 items-center"
            >
              <MdOutlineDocumentScanner className="text-white text-lg animate-pulse" />
              Resume
            </Button>
          </a>
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative py-3"
      >
        <img
          src={profile}
          alt="Sastik Kumar Das"
          className="w-36 md:w-60 z-10 shadow drop-shadow-xl rounded-full"
        />
        <SiTailwindcss className="absolute -top-0 -left-10 text-light-blue-800 text-3xl animate-pulse cursor-zoom-in" />
        <SiReact className="absolute -right-10 bottom-1 text-light-blue-800 text-3xl animate-spin cursor-zoom-in" />
        <SiHtml5 className="absolute left-2  text-red-300 text-3xl animate-pulse cursor-zoom-in" />
        <SiJavascript className="absolute -top-4 right-0 text-amber-500 text-2xl animate-pulse cursor-zoom-in" />
      </motion.div>
    </section>
  );
};

export default hero;
